var path = 'app/scripts/modules/amazon/src/pipeline/stages/tagImage/tagImageStage.html';
var html = "<div ng-controller=\"awsTagImageStageCtrl as tagImageStageCtrl\" class=\"form-horizontal\">\n  <stage-config-field label=\"Tags\">\n    <map-editor model=\"stage.tags\" allow-empty=\"true\"></map-editor>\n  </stage-config-field>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/amazon/src/pipeline/stages/tagImage/tagImageStage.html
// module id = 1235
// module chunks = 0